interface SelectProps extends React.SelectHTMLAttributes<HTMLSelectElement> {}

export function Select({ className = '', ...props }: SelectProps) {
  return (
    <select
      className={`bg-slate-900 border border-slate-700 rounded-md px-3 py-2 text-sm text-slate-100 w-full focus:outline-none focus:border-blue-500 appearance-none ${className}`}
      {...props}
    />
  );
}
